import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ISendResetCodeResult {
  message: string;
}

export interface IVerifyResetCodeResult {
  resetToken: string;
}

/**
 * Self-service password reset against the MyHivve API (two-step: verify the emailed code first,
 * then set the new password with the returned single-use reset token). All three endpoints are
 * anonymous and answer uniformly regardless of whether the account exists.
 */
@Injectable({ providedIn: 'root' })
export class PasswordResetService {
  constructor(private http: HttpClient) {}

  send(identifier: string): Observable<ISendResetCodeResult> {
    return this.http.post<ISendResetCodeResult>('/account/password-reset/send', { identifier });
  }

  verify(identifier: string, code: string): Observable<IVerifyResetCodeResult> {
    return this.http.post<IVerifyResetCodeResult>('/account/password-reset/verify', {
      identifier,
      code
    });
  }

  complete(resetToken: string, newPassword: string): Observable<void> {
    return this.http.post<void>('/account/password-reset/complete', { resetToken, newPassword });
  }
}
